<template>
  <div class="reject-document">
    <p>{{ $t('rejectDocument.rejectWarning') }}</p>
    <p>{{ $t('rejectDocument.areYouSure') }}</p>
    <div class="reject-document__reason">
      <b>{{ $t('rejectDocument.reason') }}</b>
      <textarea ref="reason"></textarea>
    </div>
  </div>
</template>

<script>
  import { rejectDocument } from '@/store/api';

  export default {
    name: 'reject-document',
    created() {
      this.$bus.$on('rejectDocument', () => {
        if (window.IS_PREVIEW) {
          alert(this.$t('rejectDocument.previewWarning'));
        } else {
          this.rejectDocument();
        }
      });
    },
    methods: {
      rejectDocument() {
        const rejectionVal = this.$refs.reason ? this.$refs.reason.value : '';
        this.$bus.$emit('loading');
        if (rejectionVal.length > 1) {
          rejectDocument({ store: this.$store, reason: rejectionVal })
            .then(() => {
              this.$bus.$emit('submitEnvelope', {
                response: {
                  status: 'rejected',
                },
              });
            });
        } else {
          alert(this.$t('rejectDocument.reasonRequired'));
          this.$bus.$emit('loadingStop');
        }
      },
    },
  };
</script>

<style lang="sass" scoped>
  @import '~styles/component-utils.sass';
  .reject-document
    p
      &:first-child
        margin-top: 0;
    textarea
      width: 100%;
      max-width: 100%;
      height: 100px;
    b
      display: block;
      margin-bottom: $spacing-small;
</style>



// WEBPACK FOOTER //
// RejectDocument.vue?6c36b36b